import {
  BOOT,
  FETCH_ACCOUNTS, FETCH_CONDITIONS,
  FETCH_CONSUMPTIONS,
  FETCH_DESCRIPTOR_TYPES,
  FETCH_DESCRIPTORS,
  FETCH_ECHAS,
  FETCH_FLOWS,
  FETCH_MIXTURES,
  FETCH_PRODUCT_FLOWS,
  FETCH_PRODUCT_RAW_MATERIALS,
  FETCH_PRODUCT_STEPS,
  FETCH_PRODUCTS,
  FETCH_RAW_MATERIALS, FETCH_SCENARIO_DESCRIPTOR_CONDITIONS, FETCH_SCENARIO_DESCRIPTORS, FETCH_SCENARIOS,
  FETCH_STEP_RAW_MATERIALS,
  FETCH_RAW_MATERIAL_SUPPLIERS,
  FETCH_STEPS,
  FETCH_SUPPLIER_REGISTERS,
  FETCH_SUPPLIERS,
  FETCH_UNITS,
  FETCH_USERS,
  FULFILLED,
  REJECTED,
  UPDATE_ADMIN_ACCOUNT
} from 'actionTypes';
import { all, fork, put, take, takeLatest } from 'redux-saga/effects';

// reducer
// Reducer moficactions are taken care in UI reducer
export default (state = {}, { type, payload }) => {
  switch (type) {
    case BOOT:
    // Switching customer boots, but only after two requests - `change_account`
    // and `/users/me/`. The loader belongs to the CLICK, not to the boot the
    // click eventually reaches, or the old customer's rows sit there looking
    // answerable for as long as the network takes.
    case UPDATE_ADMIN_ACCOUNT:
    // And again on the action that empties the store, because that emptying
    // reaches this slice too: without a case here `booting` would come back
    // undefined for the render between the emptying and the BOOT.
    case UPDATE_ADMIN_ACCOUNT + FULFILLED:
      return { ...state, booting: true };

    case BOOT + FULFILLED:
    // A switch that failed has to give the screen back. Nothing else turns this
    // off, so without it the loader spins for ever on a 403.
    case UPDATE_ADMIN_ACCOUNT + REJECTED:
      return { ...state, booting: false };

    default:
      return state;
  }
};

// sagas
function* watchBoot() {
  yield takeLatest(BOOT, boot);
}


const boot = function* () {
  try {
    // No branch, and that is the point of this shape.
    //
    // There used to be three boots - BOOT_ADMIN, BOOT_MANAGER, BOOT_STAFF -
    // chosen by reading /profile/ first and looking at two flags. All three
    // differed by ONE line: whether to ask for /users/, because the API answered
    // 403 to anyone who was not an administrator. One sequential round trip and
    // three actions, to avoid one 403.
    //
    // Both routes are scoped now - each answers with what the caller may see -
    // so there is nothing left to decide before starting. And there is no
    // profile to fetch at all: the caller's row comes with /users/ below, like
    // every other row, and the only thing that had to be known first is the id,
    // which /users/me answered before this action was dispatched.
    yield put({ type: FETCH_USERS });
    yield put({ type: FETCH_ACCOUNTS });
    yield put({ type: FETCH_UNITS });
    yield put({ type: FETCH_CONDITIONS });
    yield put({ type: FETCH_DESCRIPTOR_TYPES });
    yield put({ type: FETCH_DESCRIPTORS });
    yield put({ type: FETCH_ECHAS });
    yield put({ type: FETCH_SUPPLIERS });
    yield put({ type: FETCH_RAW_MATERIALS });
    yield put({ type: FETCH_CONSUMPTIONS });
    yield put({ type: FETCH_FLOWS });
    yield put({ type: FETCH_STEPS });
    yield put({ type: FETCH_STEP_RAW_MATERIALS });
    yield put({ type: FETCH_RAW_MATERIAL_SUPPLIERS });
    yield put({ type: FETCH_SCENARIOS });
    yield put({ type: FETCH_SCENARIO_DESCRIPTORS });
    yield put({ type: FETCH_SCENARIO_DESCRIPTOR_CONDITIONS });
    yield put({ type: FETCH_PRODUCTS });
    // The four join tables the API used to hand over nested inside their
    // parents. Their ducks, reducers and sagas have always existed; nothing
    // ever dispatched the fetch, so the slices sat empty and the screens read
    // the copy embedded in the parent instead. Fetching them is additive - the
    // nested copy is still there until the serializers drop it - and it is what
    // lets a screen join by id rather than read a duplicate that goes stale the
    // moment anybody edits the original.
    yield put({ type: FETCH_MIXTURES });
    yield put({ type: FETCH_PRODUCT_RAW_MATERIALS });
    yield put({ type: FETCH_PRODUCT_FLOWS });
    yield put({ type: FETCH_PRODUCT_STEPS });
    // The fifth, and the one the deepest screen needs. A shipment used to
    // arrive carrying the substances of its raw material, and inside each of
    // those the registers filtered down to that shipment - four levels of
    // nesting to say a thing the join table says in one row. 1072 rows, with
    // raw_material_supplier_id and mixture_substance_id on each, which are
    // exactly the two keys that reproduce the filter.
    yield put({ type: FETCH_SUPPLIER_REGISTERS });
    yield all([
      // In the barrier like everything else. The app renders nothing until this
      // resolves - App.js shows a Loader while `booting` - so what belongs here
      // is whatever the first screen needs, and the header needs the account's
      // name.
      take(FETCH_USERS + FULFILLED),
      take(FETCH_ACCOUNTS + FULFILLED),
      take(FETCH_UNITS + FULFILLED),
      take(FETCH_CONDITIONS + FULFILLED),
      take(FETCH_DESCRIPTOR_TYPES + FULFILLED),
      take(FETCH_DESCRIPTORS + FULFILLED),
      take(FETCH_ECHAS + FULFILLED),
      take(FETCH_SUPPLIERS + FULFILLED),
      take(FETCH_RAW_MATERIALS + FULFILLED),
      take(FETCH_RAW_MATERIAL_SUPPLIERS + FULFILLED),
      take(FETCH_CONSUMPTIONS + FULFILLED),
      take(FETCH_FLOWS + FULFILLED),
      take(FETCH_STEPS + FULFILLED),
      take(FETCH_STEP_RAW_MATERIALS + FULFILLED),
      take(FETCH_SCENARIOS + FULFILLED),
      take(FETCH_SCENARIO_DESCRIPTORS + FULFILLED),
      take(FETCH_SCENARIO_DESCRIPTOR_CONDITIONS + FULFILLED),
      take(FETCH_PRODUCTS + FULFILLED),
      take(FETCH_MIXTURES + FULFILLED),
      take(FETCH_PRODUCT_RAW_MATERIALS + FULFILLED),
      take(FETCH_PRODUCT_FLOWS + FULFILLED),
      take(FETCH_PRODUCT_STEPS + FULFILLED),
      take(FETCH_SUPPLIER_REGISTERS + FULFILLED),
    ]);
    yield put({ type: BOOT + FULFILLED });
  } catch (error) {
    console.log(error);
  }
};


const sagas = [
  fork(watchBoot)
];

export { sagas };
